import { STORY_SCENE_IDS } from "../../src/game/story";
import { NO_CONSUMABLES } from "../../src/game/Consumable";
import { ALL_ARTICLE_IDS } from "../../src/game/manual";
import { GameState } from "../../src/game/GameState";
import { Board } from "../../src/game/Materials";
import { STARTER_SKILLS } from "../../src/game/Skill";

function palletStock(id: string, length: Board["length"]): Board {
  return {
    id,
    type: "board",
    species: "pallet",
    length,
    width: 4,
    thickness: 4,
    surface: "rough",
    jointedFaces: 1,
    jointedEdges: 2,
  };
}

/**
 * A shop staged for the hand-tool chain: a bare workspace (both tool slots
 * free), enough money for the hand saw, the drill, and a box of screws, and
 * five pallet boards piled at the player's feet — four already crosscut
 * to 2', one still at 3' so the hand saw has a cut to make. Piled, not
 * carried: the arms have to be free to lift the bought tools out of the
 * truck's bed.
 */
export const handToolsShop: GameState = {
  minute: 0,
  day: 1,
  dayStartMinute: 0,
  money: 150,
  reputation: 0,
  materialPiles: [
    palletStock("fx-long-board", 36),
    palletStock("fx-slat-1", 24),
    palletStock("fx-slat-2", 24),
    palletStock("fx-slat-3", 24),
    palletStock("fx-slat-4", 24),
  ].map((material) => ({ material, position: [1.5, 4.5], rotation: 0 })),
  consumables: NO_CONSUMABLES,
  clamps: 0,
  player: {
    name: "Player",
    position: [1, 4], // the workspace's operation cell
    direction: 0,
    inventory: [],
    away: null,
  },
  machines: [
    {
      machineTypeId: "workspace",
      position: [1, 2],
      rotation: 0,
      inputMaterials: [],
      processingMaterials: [],
      outputMaterials: [],
      tools: [],
      selectedOperationId: "dismantlePallet",
      operationProgress: {
        status: "notStarted",
        phaseIndex: 0,
        minutesRemaining: 0,
      },
    },
  ],
  machineCrates: [],
  truck: { bed: [], crates: [] },
  storage: {
    upgrades: [],
  },
  shopInfo: {
    name: "One Car Garage",
    electricity: 120,
    size: [12, 16],
    materialDropoffPosition: [10, 13],
    entrancePosition: [6, 15],
  },
  progression: {
    tutorials: {
      opening: { step: 0, dismissed: true },
      firstNight: { step: 1, dismissed: false },
      dust: { step: 0, dismissed: false },
    },
    storeUnlocked: true,
    standUnlocked: true,
    // A staged shop is past the opening: every scene has played
    story: { scenesPlayed: [...STORY_SCENE_IDS] },
    lumberyardUnlocked: false,
    salesCompleted: 2,
    sweepingUnlocked: false,
    unlockedArticles: ALL_ARTICLE_IDS,
    readArticles: ALL_ARTICLE_IDS,
    xp: 0,
    skillPoints: 0,
    // The planter box moved to rusticProjects when the plan pile was
    // trimmed to just the shelf at the start
    unlockedSkills: [...STARTER_SKILLS, "rusticProjects"],
  },
  stand: [],
  standSetUp: true,
  customers: [],
  dust: {},
  shopVac: null,
  broomOwned: true,
  broomPosition: [0, 0],
  dustpan: {},
};
